/**
 * Mixin for sidebar menu permission and role checks.
 * Used by SidebarMenu and SidebarMenuItem components.
 */
export default {
  methods: {
    hasPermission(item) {
      const perm = item.permission
      if (!perm) return true
      if (typeof perm === 'boolean') return perm
      if (typeof perm === 'function') return perm(this)
      if (typeof this.$allows !== 'function') return true
      if (Array.isArray(perm)) return perm.some((p) => this.$allows(p))
      return this.$allows(perm)
    },
    hasRole(role) {
      if (role === 'company') {
        return this.$account && this.$account.company && !this.$allows('administer')
      }
      if (role === 'partner-company') {
        return (this.$account && this.$account.partner) || (this.$account && this.$account.company)
      }
      return false
    },
    filterMenuByPermission(items) {
      if (!items || !items.length) return []
      return items
        .map((item) => {
          let hasPermission = true
          if (item.permission) {
            if (typeof item.permission === 'function') {
              hasPermission = item.permission(this)
            } else if (typeof item.permission === 'boolean') {
              hasPermission = item.permission
            } else if (Array.isArray(item.permission)) {
              hasPermission = !this.$allows || item.permission.some((p) => this.$allows(p))
            } else {
              hasPermission = !this.$allows || this.$allows(item.permission)
            }
          }
          if(item.role) {
            hasPermission = this.hasRole(item.role)
          }
          if (!hasPermission) return null
          const filtered = { ...item }
          if (filtered.children && filtered.children.length) {
            filtered.children = this.filterMenuByPermission(filtered.children)
            if (!filtered.children.length && !filtered.route) return null
          }
          return filtered
        })
        .filter(Boolean)
    },
  },
}
